

var _checkout = require('xo-models/src/checkout');

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

try {
    var token = window.meta.token;
    _bluebird2['default'].join(_checkout.$CheckoutAppDataModel.instance(token).retrieve(), _checkout.$CheckoutCartModel.instance(token).retrieve(), function (appData, cart) {
        if (appData.doec_on_approve()) {
            window.fptiProductOverride = 'wps';
        } else if (cart.isBilling()) {
            window.fptiProductOverride = 'billing';
        }
    })['catch'](function (e) {
        console.error(e);
    });
} catch (e) {
    console.error(e);
}

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;


//////////////////
// WEBPACK FOOTER
// ./js/lib/cplIntegration.js
// module id = ./js/lib/cplIntegration.js
// module chunks = 1